import { AdacText, AdacTextType } from '@adac-de/component-library';
import React from 'react';
import { clsx } from 'clsx';
import styles from './list.module.scss';

type ListItemProps = {
  content: string;
  className?: string;
  textType?: AdacTextType;
};

type ListProps = {
  listItems: string[];
  listClassName?: string;
  listItemClassName?: string;
  textType?: AdacTextType;
};

const ListItem: React.FC<ListItemProps> = ({ content, className, textType = 'normal' }) => (
  <li className={clsx(styles.listItem, className)}>
    <AdacText type={textType}>{content}</AdacText>
  </li>
);

export const List: React.FC<ListProps> = ({
  listItems,
  listClassName,
  listItemClassName,
  textType
}) => (
  <ul className={clsx(styles.list, listClassName)}>
    {listItems?.map(item => (
      <ListItem key={item} content={item} className={listItemClassName} textType={textType} />
    ))}
  </ul>
);
